export default "__VITE_ASSET__RhlL8gR___"